import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as style from './ModalFooter.styl';
export class ModalFooter extends React.Component {
    render() {
        return (_jsx("div", Object.assign({ className: style.global }, { children: _jsx("div", Object.assign({ className: "actionBar" }, { children: this.props.children })) })));
    }
}
